(function () {
  function ready(fn) {
    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', fn);
    } else {
      fn();
    }
  }

  /*
    Sadeleştirme ala-text-fold.js içindeki ortak işlevden gelir. Buradaki
    eski sürüm NFD ile ayrışmayan harfleri (ø, ł, đ, ß, æ) ve Türkçe ı
    harfini kaçırıyordu; ortak sürüm bunları da karşılar.
    Ortak dosya bir sebeple yüklenmezse arama çalışmaya devam etsin diye
    eski davranış yedek olarak durur.
  */
  function normalize(str) {
    if (window.AlaText && window.AlaText.fold) return window.AlaText.fold(str);
    return String(str || '')
      .toLowerCase()
      .normalize('NFD')
      .replace(/[\u0300-\u036f]/g, '');
  }

  function escapeHtml(str) {
    return String(str)
      .replace(/&/g, '&amp;')
      .replace(/</g, '&lt;')
      .replace(/>/g, '&gt;')
      .replace(/"/g, '&quot;');
  }

  ready(function () {
    var root = document.querySelector('[data-artvee-search]');
    if (!root) return;

    var form = root.querySelector('[data-artvee-form]');
    var input = root.querySelector('[data-artvee-input]');
    var meta = root.querySelector('[data-artvee-meta]');
    var results = root.querySelector('[data-artvee-results]');
    var indexUrl = root.getAttribute('data-index-url');
    var galleries = [];

    function setMeta(text) {
      if (meta) meta.textContent = text;
    }

    function render(hits, query) {
      results.innerHTML = '';
      if (!query) {
        setMeta(galleries.length + ' galeri indekslendi. Arama yazın.');
        return;
      }
      setMeta('"' + query + '" - ' + hits.length + ' sonuç / ' + galleries.length + ' galeri');
      if (!hits.length) {
        var empty = document.createElement('p');
        empty.className = 'artvee-search__empty';
        empty.textContent = 'Eşleşme yok.';
        results.appendChild(empty);
        return;
      }
      var frag = document.createDocumentFragment();
      hits.forEach(function (item) {
        var li = document.createElement('li');
        li.className = 'artvee-search__item';
        var a = document.createElement('a');
        a.className = 'artvee-search__link';
        a.href = item.url;
        a.target = '_blank';
        a.rel = 'noopener noreferrer';
        a.innerHTML =
          '<p class="artvee-search__item-title">' +
          escapeHtml(item.title) +
          '</p>' +
          (item.author
            ? '<p class="artvee-search__item-author">by ' + escapeHtml(item.author) + '</p>'
            : '');
        li.appendChild(a);
        frag.appendChild(li);
      });
      results.appendChild(frag);
    }

    function search(query) {
      var q = normalize(query.trim());
      if (!q) {
        render([], '');
        return;
      }
      var hits = galleries.filter(function (item) {
        return (
          normalize(item.title).indexOf(q) !== -1 ||
          normalize(item.author).indexOf(q) !== -1
        );
      });
      render(hits, query.trim());
    }

    fetch(indexUrl)
      .then(function (res) {
        if (!res.ok) throw new Error('Index yüklenemedi');
        return res.json();
      })
      .then(function (data) {
        galleries = Array.isArray(data) ? data : [];
        setMeta(galleries.length + ' galeri indekslendi. Arama yazın.');
        var params = new URLSearchParams(window.location.search);
        var initial = params.get('q') || '';
        if (initial) {
          input.value = initial;
          search(initial);
        }
      })
      .catch(function () {
        setMeta('Galeri indeksi yüklenemedi.');
      });

    form.addEventListener('submit', function (e) {
      e.preventDefault();
      var q = input.value.trim();
      var url = new URL(window.location.href);
      if (q) url.searchParams.set('q', q);
      else url.searchParams.delete('q');
      window.history.replaceState({}, '', url);
      search(q);
    });

    var debounce;
    input.addEventListener('input', function () {
      clearTimeout(debounce);
      debounce = setTimeout(function () {
        search(input.value);
      }, 180);
    });
  });
})();
